import { render, staticRenderFns } from "./veritabanidetails.vue?vue&type=template&id=7b7308b4&"
import script from "./veritabanidetails.vue?vue&type=script&lang=js&"
export * from "./veritabanidetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports